import * as UI from "@iyk/ui"
import { Carousel } from "../../../packages/carousel.tsx"
import { HowItWorksCarousel } from "../../../packages/how-it-works-carousel.tsx"
import { Sheet } from "./sheet.tsx"

const Root = ({ children }: { children: React.ReactNode }) => {
  return (
    <Sheet.Root>
      <Sheet.Content title="How it works" description="How does the hunt work?">
        <div className="py-8">
          <HowItWorksCarousel.Root>
            <Content />
          </HowItWorksCarousel.Root>
        </div>
      </Sheet.Content>

      {children}
    </Sheet.Root>
  )
}

const Content = () => {
  const { goToNextSlide, selectedScrollSnap, scrollSnapList } = Carousel.useCarousel()
  const isLastSlide = selectedScrollSnap() === scrollSnapList().length - 1

  return (
    <div className="flex flex-col gap-8">
      <HowItWorksCarousel.Content />

      <div className="px-4">
        {isLastSlide ? (
          <Sheet.Close
            className={UI.classForButton({ size: "lg", kind: "solid", className: "w-full" })}
          >
            Got it
          </Sheet.Close>
        ) : (
          <UI.Button
            type="button"
            kind="solid"
            size="lg"
            className="w-full"
            onClick={goToNextSlide}
          >
            Next
          </UI.Button>
        )}
      </div>
    </div>
  )
}

const Trigger = Sheet.Trigger

export const HowItWorksSheet = {
  Root,
  Trigger,
}
